<template>
  <div>
      <ul class="server-item">
          <li v-for="(k,v) in printerList">
              <img :src="k.pictureUrlOne">
              <span>{{k.briefIntroduction}}</span>
              <p>￥{{k.price}}</p>
              <Button type="primary" ghost><a :href="k.jumpUrl" target="_blank">立即购买</a></Button>
          </li>
      </ul>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
          printerList:{}
      }
    },

    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {

      });
    },
    created: function() {
      //DOM更新完之前请求数据
        this.getPrinter()
    },
    methods: {
        getPrinter(){
            let data = {
                productType:1
            };
            this.$Api.getPrintAppreciationServe(data).then(res => {
                if(res.code==200){
                    this.printerList = res.data
                }else {
                    this.$Message.warning(res.msg);
                }
            });
        },

    }
  }
</script>


<style  lang="scss" scoped>
.server-title{
    display: inline-block;
    text-align: center;width: 88%
}
.server-item li{
    margin:0 auto 26px;
    position: relative;
    float: left;
    background: #ffffff;
    margin: 20px;
    width: 328px;
    height: 75px;
    border-radius: 5px;
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    padding-left: 75px;
    color: #333333;
    padding-top: 18px;
    img{
        position: absolute;
        left: 14px;
        top: 12px;
        width: 50px;
        height: 50px;
    }
    p{
        color: #ff795e;
    }
    Button{
        position: absolute;
        top: 25px;
        right: 15px;
    }
}
</style>